import { render } from "./BlogLeftSidebar.vue?vue&type=template&id=6f13cb0c"
import script from "./BlogLeftSidebar.vue?vue&type=script&lang=js"
export * from "./BlogLeftSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__